import { useEffect, useState } from 'react';
import { supabase } from '../../../../supabaseClient';
import { alertSuccess } from '../../../../components/Toast';
import { inPlaceSort } from 'fast-sort';
import { FaTrashCan } from 'react-icons/fa6';
import { LabelCreatable } from '../../../../components/Input/Input';

export const useTypeOs = ({
  company,
  setReloadPrint,
  setValues,
  onChange,
  setHasCreatedTypeOS,
  values,
  reloadTypeOS,
}) => {
  const [typeOS, setTypeOS] = useState([]);
  const [menuTypeOSOpen, setMenuTypeOSOpen] = useState();

  const creatableOpenTypeOS = (e) => {
    if (e.target.id === 'react-select-6-input') {
      setMenuTypeOSOpen(true);
    } else if (e.target.id === 'path') {
      setMenuTypeOSOpen(true);
    }
  };

  useEffect(() => {
    loadTypeOS();
  }, [company.id, reloadTypeOS]);

  const loadTypeOS = async () => {
    let { data, error } = await supabase
      .from('TypeOS')
      .select('*')
      .eq('id_company', company.id)
      .is('deleted_at', null);

    if (!error) {
      setTypeOS(
        data.map((item) => ({ ...item, label: item.os_type.label, value: item.id }))
      );
    }
  };

  const deleteTypeOSOption = async (id, e) => {
    e.preventDefault();
    e.stopPropagation();
    const { data, error } = await supabase
      .from('TypeOS')
      .update({ deleted_at: new Date() })
      .eq('id', id);

    if (!error) {
      setTypeOS(typeOS.filter((options) => options.id !== parseInt(id)));
      alertSuccess('Deletado com sucesso');
    }
  };

  const createTypeOSOption = async (name, field) => {
    setReloadPrint((reload) => !reload);
    setValues((values) => ({
      ...values,
      [field]: { label: name, value: '0' },
    }));

    setHasCreatedTypeOS((prev) => !prev);
  };

  const divCreatableTypeOS = (data, e) => {
    if (data.id) {
      e.preventDefault();
      onChange('os_type', { label: data.label, value: data.id });
    } else {
      setValues((values) => ({
        ...values,
        os_type: { label: data.value, value: '0' },
      }));
      setHasCreatedTypeOS((prev) => !prev);
    }
    setReloadPrint((reload) => !reload);
    e.type === 'click' ? setMenuTypeOSOpen(false) : null;
  };

  const sortedTypeOSOptions = typeOS.map((item) => ({
    value: item.os_type.value,
    label: item.os_type.label,
    id: item.id,
  }));

  inPlaceSort(typeOS).asc([
    (item) => item.label?.replace(/[^a-zA-Z]/g, '').toLowerCase(),
    (item) => {
      const numberMatch = item.label?.match(/\d+/);
      return numberMatch ? parseInt(numberMatch[0], 10) : 0;
    },
  ]);

  const OptionFuncTypeOS = (props) => {
    const { data } = props;
    return (
      <div
        {...props}
        className="deletable-creatable"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '40px',
          padding: '10px',
        }}
      >
        <div
          onClick={(e) => divCreatableTypeOS(data, e)}
          style={{
            textTransform: 'uppercase',
            width: '100%',
            height: '40px',
            alignContent: 'center',
          }}
        >
          {data?.label}
        </div>
        <div>
          <FaTrashCan
            style={{ color: 'rgb(255 130 120)' }}
            onClick={(e) => deleteTypeOSOption(data.id, e)}
          />
        </div>
      </div>
    );
  };

  const InputTypeOS = () => (
    <div className="payment-dropdown">
      <div onClick={(e) => creatableOpenTypeOS(e)} className="void-class">
        <LabelCreatable
          // menuIsOpen={menuTypeOSOpen}
          onCreateOption={(name) => createTypeOSOption(name, 'os_type')}
          components={{ Option: (props) => OptionFuncTypeOS(props) }}
          options={inPlaceSort(sortedTypeOSOptions).asc([
            (item) => item.label.replace(/[^a-zA-Z]/g, '').toLowerCase(),
            (item) => {
              const numberMatch = item.label.match(/\d+/);
              return numberMatch ? parseInt(numberMatch[0], 10) : 0;
            },
          ])}
          defaultValue={values?.os_type}
          onChange={(value) => onChange('os_type', value)}
          placeholder={'INSIRA O Tipo da OS'}
          label={'Tipo da OS'}
          className="generic-input select-creatable budget-percentage-input budget-creatable"
          styles={{
            option: (base) => ({
              ...base,
              border: ``,
              height: '100%',
            }),
          }}
        />
      </div>
    </div>
  );

  return {
    InputTypeOS,
  };
};
